"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("../../styles");
const styles = styles_1.createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        listStyle: 'none',
        margin: 0,
        padding: 0,
    },
});
exports.decorate = styles_1.withStyles(styles);
